import {create} from 'zustand';
import {UseConfirmCommunicationHasErrorStore} from './types';

const useConfirmCommunicationHasErrorStore = create<UseConfirmCommunicationHasErrorStore>(set => ({
	confirmCommunicationHasError: false,
	setConfirmCommunicationHasError: value => set({confirmCommunicationHasError: value}),
	resetConfirmCommunicationHasError: () => set({confirmCommunicationHasError: false}),
}));

export {useConfirmCommunicationHasErrorStore};
